import { DOCUMENT } from '@angular/common';
import {
  Component,
  ChangeDetectionStrategy,
  Input,
  Inject,
  OnInit,
} from '@angular/core';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';
import { TranslateService } from '@ngx-translate/core';
import { environment } from 'src/environments/environment';

@Component({
  selector: 'app-analysis-video-modal',
  templateUrl: './video-modal.component.html',
  styleUrls: ['./video-modal.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class VideoModalComponent implements OnInit {
  @Input() videoId: string;
  @Input() forceCC = false;

  cc = [];
  playerVars: YT.PlayerVars;

  constructor(
    public readonly modal: NgbActiveModal,
    private translate: TranslateService,
    @Inject(DOCUMENT) private document
  ) {
    environment.locations.forEach((location) => {
      if (location.lang.videoSubtitles) {
        this.cc.push(location.lang.code);
      }
    });
  }

  ngOnInit() {
    this.playerVars = {
      enablejsapi: 1,
      origin: this.document.location.origin,
      showinfo: 0,
      modestbranding: 1,
      // eslint-disable-next-line @typescript-eslint/naming-convention
      cc_load_policy: this.setPolicy(),
      hl: this.setLanguage(),
      rel: 0,
    };
  }

  setPolicy() {
    return this.cc.includes(this.translate.currentLang) && this.forceCC ? 1 : 0;
  }

  setLanguage() {
    return this.forceCC ? this.translate.currentLang : null;
  }
}
